var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HouseLine"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.625 0H0.625V24H24.625V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.875 20.2501V10.8319C20.875 10.7274 20.8532 10.624 20.8109 10.5284C20.7686 10.4329 20.7068 10.3472 20.6295 10.2769L13.129 3.45799C12.9909 3.33248 12.811 3.26293 12.6245 3.26294C12.4379 3.26295 12.258 3.3325 12.1199 3.45803L4.62045 10.2769C4.54314 10.3472 4.48137 10.4329 4.4391 10.5284C4.39683 10.624 4.375 10.7273 4.375 10.8318V20.2501",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.875 20.2501V10.8319C20.875 10.7274 20.8532 10.624 20.8109 10.5284C20.7686 10.4329 20.7068 10.3472 20.6295 10.2769L13.129 3.45799C12.9909 3.33248 12.811 3.26293 12.6245 3.26294C12.4379 3.26295 12.258 3.3325 12.1199 3.45803L4.62045 10.2769C4.54314 10.3472 4.48137 10.4329 4.4391 10.5284C4.39683 10.624 4.375 10.7273 4.375 10.8318V20.2501",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 20.2493V14.9993C14.875 14.8004 14.796 14.6096 14.6553 14.4689C14.5147 14.3283 14.3239 14.2493 14.125 14.2493H11.125C10.9261 14.2493 10.7353 14.3283 10.5947 14.4689C10.454 14.6096 10.375 14.8004 10.375 14.9993V20.2493",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 20.2493V14.9993C14.875 14.8004 14.796 14.6096 14.6553 14.4689C14.5147 14.3283 14.3239 14.2493 14.125 14.2493H11.125C10.9261 14.2493 10.7353 14.3283 10.5947 14.4689C10.454 14.6096 10.375 14.8004 10.375 14.9993V20.2493",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.125 20.25H23.125",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.02ffbadb4730c2734bc9998dfb801779.svg";
export { ForwardRef as ReactComponent };